import React from 'react';
import { Modal, Container, Row, Col } from 'reactstrap';

import { withNamespaces } from 'react-i18next';

import { ApiContext } from 'src/utils/ApiContext';

export default withNamespaces()(ModalTrancSelect);
function ModalTrancSelect(props) {
  const { t } = props;
  const { showModalTranc } = props;

  const context = React.useContext(ApiContext);

  return (
    <Modal
      isOpen={context.showTrancSelect}
      toggle={() => context.setShowTrancSelect(false)}
      zIndex={1}
    >
      <Container style={{ padding: 20, background: '#1E3845' }}>
        <Row className={'justify-content-center align-items-center'}>
          <div style={{ color: 'whitesmoke' }}>{t('ModalTrancSelect.PleaseSelectTheWayToDeposit')}</div>
        </Row>

        <Row className={'justify-content-center align-items-center'}>
          <Col xs={3}>
            <button
              className={'btn btn-outline-success my-2'}
              onClick={() => {
                showModalTranc();
                context.setShowTrancSelect(false);
              }}
            >
              {t('ModalTrancSelect.PayName')}
            </button>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};
